import Washi from 'washi';
import Modal from './mixins/modal';
import Cookies from 'cookies-js';
const modalCookie = 'banner-promotion-modal';

const BannerPromotionModal = Washi.$.extend(
  {
    el: '#banner-promotion-modal',

    ui: {
      close: '[data-close]',
      forceShow: '[data-force-show]',
      content: '[data-banner-promotional-modal="content"]',
      scrollTarget: '[data-banner-promotional-modal="scroll-target"]',
    },

    events: {
      'click {close}': 'hide',
    },

    /**
     * See #1928 for more implementation details
     */
    initialize() {
      const isMobile = window.innerWidth < 768;
      const forceShow = this.ui.forceShow[0].dataset.forceShow;

      if (
        (!isMobile && forceShow == 'desktop') ||
        forceShow == 'desktop_and_mobile'
      ) {
        this.onShow();
      }

      this.scrollEl = this.ui.scrollTarget[0];
      this.el.addEventListener(
        'forceShowBannerPromotionModal',
        this.onShow.bind(this, true),
      );
    },

    isSet(cookie) {
      return Cookies.get(cookie) === '1';
    },

    shouldShow(force) {
      return force === true || Cookies.get(modalCookie) !== '1';
    },

    onShow(force) {
      this.tryShow(
        () => this.shouldShow(force),
        () => {
          Cookies.set(modalCookie, '1', {
            expires: 86400, // 1 day
          });
        },
      );
    },
  },
  Modal,
);

export default BannerPromotionModal;
